import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useSnapshot } from 'valtio';
import ApplicationControls from '../components/control-components/ApplicationControls';
import ApplicationsStore from '../stores/applications-store';
import { onSearchChange } from '../actions/applications-actions';
import { clearSelectedApps } from '../stores/applications-store-actions';
import { useState, useCallback, SyntheticEvent } from 'react';
import EditPriorityModalContainer from './EditPriorityModalContainer';
import IrrelevanceConfirmationContainer from './IrrelevanceConfirmationContainer';
import OwnersModal from './OwnersModalContainer';
import { downloadBirthCertificate } from '../../birth-certificate/api/birth-certificate-api';
import { useIsScanning } from '../../new-scan/actions/scan-actions';
import {
  getSelectedAppNames,
  getSelectedAppsIDs,
} from '../utils/application-utils';
import PolicySettingsContainer from '../../policy-settings/containers/PolicySettingsContainer';
import { useFindConnectorById } from '../../connectors/api/connectors-api';

const ApplicationControlsContainer = () => {
  const { classes } = useStyles();
  const { appFilterValue, selectedCount } = useSnapshot(ApplicationsStore);
  const [showAppOwnerDialog, setShowAppOwnerDialog] = useState(false);
  const [showEditPriorityDialog, setShowEditPriorityDialog] = useState(false);
  const [showIrrelavanceConfirmation, setShowIrrelavanceConfirmation] =
    useState(false);
  const [showPolicySettingsModal, setShowPolicySettingsModal] = useState(false);
  const handleOwnersClick = useCallback(() => {
    setShowAppOwnerDialog(true);
  }, []);

  const handleEditPriorityClick = useCallback(() => {
    setShowEditPriorityDialog(true);
  }, []);

  const handleIrrelevantClick = useCallback(() => {
    setShowIrrelavanceConfirmation(true);
  }, []);

  const handlePolicySettingsClick = useCallback(() => {
    setShowPolicySettingsModal(true);
  }, []);

  const [openSBOM, setOpenSBOM] = useState(false);

  const handleOpenMenuSBOM = useCallback((e: SyntheticEvent) => {
    e.stopPropagation();
    setOpenSBOM(true);
  }, []);

  const handleCloseMenuSBOM = useCallback(() => {
    setOpenSBOM(false);
  }, []);

  const isScaninng = useIsScanning();
  const appIds = getSelectedAppsIDs();
  const appNames = getSelectedAppNames();

  const ecrConnector = useFindConnectorById('87'); //Yaniv let's do something about this

  return (
    <div className={classes.container}>
      <OwnersModal open={showAppOwnerDialog} setOpen={setShowAppOwnerDialog} />
      <EditPriorityModalContainer
        open={showEditPriorityDialog}
        setOpen={setShowEditPriorityDialog}
      />
      <IrrelevanceConfirmationContainer
        open={showIrrelavanceConfirmation}
        setOpen={setShowIrrelavanceConfirmation}
      />
      {showPolicySettingsModal && (
        <PolicySettingsContainer
          open={showPolicySettingsModal}
          setOpen={setShowPolicySettingsModal}
          appIds={appIds}
          appNames={appNames}
        />
      )}
      <ApplicationControls
        ecrConfigured={!!ecrConnector?.isConfigured}
        disabled={selectedCount === 0 || isScaninng}
        searchValue={appFilterValue}
        searchChange={onSearchChange}
        selectedCount={selectedCount}
        clearSelection={clearSelectedApps}
        handleOwnersClick={handleOwnersClick}
        handleIrrelevantClick={handleIrrelevantClick}
        handleEditPriorityClick={handleEditPriorityClick}
        handlePolicySettingsClick={handlePolicySettingsClick}
        downloadBirthCertificate={downloadBirthCertificate}
        handleOpenMenuSBOM={handleOpenMenuSBOM}
        handleCloseMenuSBOM={handleCloseMenuSBOM}
        openSBOM={openSBOM}
      />
    </div>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    marginBlock: theme.spacing(1),
  },
}));

export default ApplicationControlsContainer;
